<section *ngIf="IsSupport">
    <chat-widget authentication="d8b82aec597873cad4321ccd004539f7282125e8a36b145fabb54db0d72e1e7e"></chat-widget>
</section>

<div class="home-page">
    <section class="welcome-banner" aria-labelledby="welcome-title">
        <img class="welcome-illustration" src="assets/media/svg/homeDinoMacbook.svg" alt="" />
        <div class="welcome-copy">
            <h1 id="welcome-title">¡<ng-container *ngIf="(appStateService.UserCompanyInfo | async) as user; else loadingName">{{user.name || 'Hola'}}</ng-container>, bienvenid&#64; a tu <span>portal Defontana!</span></h1>
            <p>Descubre todo lo que Defontana tiene para ti.</p>
        </div>
        <ng-template #loadingName><span class="loading-name" aria-label="Cargando nombre"></span></ng-template>
    </section>

    <section class="modules-section" aria-label="Accesos a módulos">
        <div class="modules-toolbar">
            <div class="module-tabs" role="tablist" aria-label="Módulos">
                <button #recentTab id="recent-tab" type="button" role="tab" [attr.aria-selected]="activeTab === 'recent'"
                    [attr.tabindex]="activeTab === 'recent' ? 0 : -1"
                    aria-controls="modules-panel" [class.active]="activeTab === 'recent'"
                    (click)="selectTab('recent')" (keydown.arrowRight)="selectTab('modules'); modulesTab.focus()">Módulos recientes</button>
                <button #modulesTab id="my-modules-tab" type="button" role="tab" [attr.aria-selected]="activeTab === 'modules'"
                    [attr.tabindex]="activeTab === 'modules' ? 0 : -1"
                    aria-controls="modules-panel" [class.active]="activeTab === 'modules'"
                    (click)="selectTab('modules')" (keydown.arrowLeft)="selectTab('recent'); recentTab.focus()">Mis módulos</button>
            </div>
            <small class="last-access">{{lastAccess}}</small>
        </div>

        <div id="modules-panel" role="tabpanel" [attr.aria-labelledby]="activeTab === 'recent' ? 'recent-tab' : 'my-modules-tab'">
            <ng-container *ngIf="activeTab === 'recent'; else myModules">
                <ng-container *ngIf="product$ | async as state">
                    <ng-container *ngIf="!state.error; else productsError">
                        <app-layout-products appearance="home" [Products]="state.products"></app-layout-products>
                        <p class="empty-state" *ngIf="state.products?.length === 0">Todavía no tienes módulos recientes.</p>
                    </ng-container>
                </ng-container>
            </ng-container>
            <ng-template #myModules>
                <ng-container *ngIf="categories$ | async as state">
                    <ng-container *ngIf="!state.error; else productsError">
                        <app-layout-products *ngIf="!state.categories" appearance="home"></app-layout-products>
                        <section class="module-category" *ngFor="let category of state.categories">
                            <h2>{{category.name}}</h2>
                            <app-layout-products appearance="home" [Products]="category.products"></app-layout-products>
                        </section>
                        <p class="empty-state" *ngIf="state.categories?.length === 0">No hay módulos disponibles para esta empresa.</p>
                    </ng-container>
                </ng-container>
            </ng-template>
            <ng-template #productsError>
                <div class="empty-state" role="status">
                    <p>No pudimos cargar tus módulos.</p>
                    <button type="button" (click)="retryProducts()">Volver a intentar</button>
                </div>
            </ng-template>
        </div>
    </section>

    <section class="information-section" aria-labelledby="information-title">
        <h2 id="information-title">Información</h2>
        <div class="information-grid">
            <a class="information-card" *ngFor="let item of allNews" [href]="item.href" target="_blank" rel="noopener noreferrer">
                <img [src]="item.img" alt="" loading="lazy" />
                <div><h3>{{item.title}}</h3><p>{{item.text}}</p></div>
            </a>
        </div>
    </section>
</div>
